class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      select: this.querySelector('select[name="language_code"], select[name="country_code"]'),
      form: this.querySelector('form')
    };
    this.elements.select.addEventListener('change', this.onSelectChange.bind(this));
  }

  onSelectChange(event) {
    const selectedValue = this.elements.select.value;
    console.log(selectedValue);


    // Submit the form
    if (this.elements.form) {
      this.elements.form.submit();
    }
  }
}

customElements.define('localization-form', LocalizationForm);

